export const maxSteps = 64;
export const minSteps = 0;
export const adRevenueDivider = 0.005;
export const adRevenueMax = 10000;
export const adRevenueMin = 0;
